import "@landing/tailwind.css"

import { Loading } from "@landing/components/shared/Loading"
import ErrorBoundary from "@landing/providers/ErrorBoundary"
import { PostHogProvider } from "@landing/providers/PostHogProvider"
import { NotFoundRoute } from "@landing/routes/_notFound"
import { keepPreviousData, QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { createRouter, RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { DisplayModeProvider } from "./providers/DisplayModeProvider"
import { routeTree } from "./routeTree.gen"

const routerBasepath = import.meta.env.BASE_URL === "/" ? "/" : import.meta.env.BASE_URL.replace(/\/$/, "")

// Tanstack query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: import.meta.env.PROD, // Disable retries in development
      placeholderData: keepPreviousData, // Prevent flash of empty content
    },
  },
})

// Tanstack router
const router = createRouter({
  routeTree,
  basepath: routerBasepath,
  context: {
    queryClient,
  },
  defaultPendingComponent: Loading,
  defaultNotFoundComponent: NotFoundRoute,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

// biome-ignore lint/style/noNonNullAssertion: root element should never be null
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <PostHogProvider>
        <QueryClientProvider client={queryClient}>
          <DisplayModeProvider>
            <RouterProvider router={router} />
          </DisplayModeProvider>
        </QueryClientProvider>
      </PostHogProvider>
    </ErrorBoundary>
  </StrictMode>,
)
